import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { productsData } from "../data/productsData";
import ProductCard from "./ProductCard";

const SearchResults = () => {
  const location = useLocation();
  const [results, setResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const query = urlParams.get("q") || "";
    setSearchTerm(query);

    if (query) {
      const filteredResults = productsData.filter((product) => {
        return (
          product.name.toLowerCase().includes(query.toLowerCase()) ||
          product.description.toLowerCase().includes(query.toLowerCase()) ||
          product.keywords.some((keyword) =>
            keyword.toLowerCase().includes(query.toLowerCase())
          )
        );
      });
      setResults(filteredResults);
    }
  }, [location.search]);

  return (
    <div className="page active">
      <h2 className="page-title">Search Results</h2>
      {results.length === 0 ? (
        <div className="search-result-item">
          <div className="search-result-title">No products found</div>
          <div className="search-result-description">
            No products match your search for "{searchTerm}". Please try
            different keywords.
          </div>
        </div>
      ) : (
        <>
          <p style={{ marginBottom: "1rem", color: "#7f8c8d" }}>
            Found {results.length} product{results.length > 1 ? "s" : ""} for "
            {searchTerm}"
          </p>
          <div className="product-grid">
            {results.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchResults;
